import styled from 'styled-components';

export const CreateAccountSubmitButtonContainer = styled.div`
  margin-top: auto;
  margin-bottom: 1rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
